import React from 'react'
import { ReactComponent as PenIcon } from 'assets/icons/pen.svg'
import { ReactComponent as CheckIcon } from 'assets/icons/check.svg'
import { ReactComponent as UniversityIcon } from 'assets/icons/university.svg'
import { ReactComponent as HierarchyIcon } from 'assets/icons/arrow-diagram.svg'
import InitialAvatar from 'shared/components/InitialAvatar/InitialAvatar'
import Header from '../Header/Header'
import WorkOverview from '../WorkOverview/WorkOverview'
import StudentList from '../StudentList/StudentList'
import s from './Profile.module.scss'

export const Profile = ({
	profile,
	profileEditing,
	studentsOpen,
	goBack,
	startProfileEdit,
	cancelProfileEdit,
	saveProfile,
	updateProfileName,
	showMoreStudents,
}) => (
	<>
		<Header
			title="Profile"
			description="Your role, school and current work at a glance."
			onBack={goBack}
		/>
		<section className={s.profile}>
			<div className={s.profile__avatar}>
				<InitialAvatar
					name={profile.name}
					size={104}
					avatarKey={profile.avatarKey}
				/>
				<button
					type="button"
					aria-label="Change profile image"
					className={s.profile__avatarEdit}
				>
					<PenIcon aria-hidden />
				</button>
			</div>
			<div className={s.profile__identity}>
				<span className={s.profile__eyebrow}>Counsellor profile</span>
				{profileEditing ? (
					<>
						<label className={s.profile__field}>
							<span className={s.profile__label}>Full name</span>
							<input
								className={s.profile__input}
								value={profile.name}
								onChange={event => updateProfileName(event.target.value)}
							/>
						</label>
						<label className={s.profile__field}>
							<span className={s.profile__label}>Email address</span>
							<input
								className={s.profile__input}
								value={profile.email}
								disabled
							/>
						</label>
					</>
				) : (
					<>
						<h2 className={s.profile__name}>{profile.name}</h2>
						<p className={s.profile__email}>{profile.email}</p>
					</>
				)}
			</div>
			<div className={s.profile__meta}>
				<div className={s.profile__metaItem}>
					<span className={s.profile__metaIcon}>
						<UniversityIcon aria-hidden />
					</span>
					<span>
						<small className={s.profile__metaLabel}>School</small>
						<strong className={s.profile__metaValue}>{profile.school}</strong>
					</span>
				</div>
				<div className={s.profile__metaItem}>
					<span className={s.profile__metaIcon}>
						<HierarchyIcon aria-hidden />
					</span>
					<span>
						<small className={s.profile__metaLabel}>Reporting to</small>
						<strong className={s.profile__metaValue}>{profile.reportsTo}</strong>
					</span>
				</div>
			</div>
			<div className={s.profile__actions}>
				{profileEditing ? (
					<>
						<button
							type="button"
							className={s.profile__secondary}
							onClick={cancelProfileEdit}
						>
							Cancel
						</button>
						<button type="button" className={s.profile__primary} onClick={saveProfile}>
							<CheckIcon aria-hidden />
							Save changes
						</button>
					</>
				) : (
					<button
						type="button"
						className={s.profile__secondary}
						onClick={startProfileEdit}
					>
						<PenIcon aria-hidden />
						Edit profile
					</button>
				)}
			</div>
		</section>
		<WorkOverview />
		<StudentList studentsOpen={studentsOpen} onShowMore={showMoreStudents} />
	</>
)

export default Profile
